module.exports = __webpack_public_path__ + "tj38pmb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ranks/29.jpg
// module id = 557
// module chunks = 1